<template>
  <PmNotificationAddressUpdatedPure v-bind="{ ...$attrs, ...props }" />
</template>

<script setup lang="ts">
import PmNotificationAddressUpdatedPure, {
  type Props as PropsNotificationAddressUpdatedPure,
} from '@/components/PmNotification/PmNotificationAddressUpdated/PmNotificationAddressUpdatedPure.vue'

export type Props = PropsNotificationAddressUpdatedPure

const props = withDefaults(defineProps<Props>(), {})
</script>
